import { useMutation } from '@tanstack/react-query';

import {
  BulkDeleteVoucherUsersBatchPayload,
  BulkDeleteVoucherUsersPayload,
  BulkDeleteVoucherUsersResponse,
  bulkDeleteVoucherUsers,
  bulkDeleteVoucherUsersBatched,
} from '~/services/PromoService';

export function useBulkDeleteVoucherUsers() {
  return useMutation<BulkDeleteVoucherUsersResponse, Error, BulkDeleteVoucherUsersPayload>({
    mutationFn: async (payload) => bulkDeleteVoucherUsers(payload),
  });
}

export function useBatchedBulkDeleteVoucherUsers() {
  return useMutation<BulkDeleteVoucherUsersResponse, Error, BulkDeleteVoucherUsersBatchPayload>({
    mutationFn: async (payload) => bulkDeleteVoucherUsersBatched(payload),
  });
}
